import { render } from "./OrdineCompletato.vue?vue&type=template&id=4acf3135"
import script from "./OrdineCompletato.vue?vue&type=script&lang=js"
export * from "./OrdineCompletato.vue?vue&type=script&lang=js"

import exportComponent from "E:\\A\\Git\\Kea\\GeneralMarketing2022\\src\\GM.Shop2022\\Areas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__